import { axios } from "utils";

import { ADMIN_PRACTICES_URL as endpoint } from "consts";

import {
  ExportDigitalAgronomistCropPracticesRequest,
  ExportDigitalAgronomistCropPracticesResponse,
  PracticeCrop,
  PracticeFertilizerApplication,
  PracticeFertilizerMineral,
  PracticeFertilizerOrganic,
  PracticeLandUseChange,
  PracticePlantProtection,
  PracticeSeeding,
  PracticeSpecification,
  PracticeTillage,
  UpdateDigitalAgronomistCropPracticesResponseBody,
} from "models";

export const getAdminAllPractices = async (): Promise<PracticeSpecification[]> => axios.get(`${endpoint}/`);

export const getAdminPracticeCrops = async ({
  enabled,
  regionId,
  version,
}: {
  enabled?: boolean;
  regionId?: string;
  version?: string;
}): Promise<PracticeCrop[]> => axios.get(`${endpoint}/crops`, { params: { enabled, regionId, version } });

export const getAdminPracticeMineralFertilizers = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerMineral[]> =>
  axios.get(`${endpoint}/mineral-fertilizers`, { params: { enabled } });

export const getAdminPracticeOrganicFertilizers = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerOrganic[]> =>
  axios.get(`${endpoint}/organic-fertilizers`, { params: { enabled } });

export const getAdminPracticeSeedings = async ({ enabled }: { enabled?: boolean }): Promise<PracticeSeeding[]> =>
  axios.get(`${endpoint}/seedings`, { params: { enabled } });

export const getAdminPracticeOrganicFertilizerApplications = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerApplication[]> =>
  axios.get(`${endpoint}/organic-fertilizers/applications`, { params: { enabled } });

export const getAdminPracticeTillages = async ({ enabled }: { enabled?: boolean }): Promise<PracticeTillage[]> =>
  axios.get(`${endpoint}/tillages`, { params: { enabled } });

export const exportDigitalAgronomistCropPractices = async ({
  countryCode,
  signal,
}: {
  countryCode: string;
  signal: AbortSignal;
}): Promise<ExportDigitalAgronomistCropPracticesResponse[]> => axios.get(`${endpoint}/exportDigitalAgronomistCropPractices/${countryCode}`, { signal });

export const updateDigitalAgronomistCropPractices = async ({
  countryCode,
  data,
}: {
  countryCode: string;
  data: ExportDigitalAgronomistCropPracticesRequest[];
}): Promise<UpdateDigitalAgronomistCropPracticesResponseBody> => axios.put(`${endpoint}/digitalAgronomistCropPractices/${countryCode}`, { data: data });

export const getPracticeLandUseChangesAdmin = async (): Promise<PracticeLandUseChange[]> => axios.get(`${endpoint}/land-use-changes`);

export const getPracticePlantProtectionsAdmin = async (): Promise<PracticePlantProtection[]> => axios.get(`${endpoint}/plant-protections`);
